
// v6.0: 增加 2025-07 增加表单填写页面 followupForm、小程序重定向页面 WxRedirect、服务号绑定手机号回调API
// V7.0.x: 增加白癜风专病；需搭配后端版本v6.2以上版本(含);  添加了用户使用空间统计
// V7.1.0: 增加黑色素瘤专病；需搭配后端版本v6.4以上版本(含);  
// V7.1.1: 增加了自定义标题；需搭配后端版本v6.5;  
// V8.0: 增加科研队列；需搭配后端版本v8.0以上版本(含);
// V8.1: 患者和诊断两个表的字段增加，响应XJ-Lshuli; 后端适配V8.1版本；增加了患者职业、饮酒习惯、饮食习惯等字段；
// V8.1.1: 美容治疗页面，患者信息修改为与影像检查页面一致；
// V8.1.2: 优化诊疗记录对话框、诊疗历史记录页面。
// V8.2: 增加Web 端验证码，使用阿里云API。
// V8.3: 增加图片标记“进展期/稳定期/无”；影像诊断页面增加多个诊断；增加页面自定义按键名称(西京要求将“影像检查”改为“检查诊断”等)；增加白癜风记录“基线”；
//       检查诊断页面增加“治疗方案”，诊断结果详情页面增加“后续检查”；
// V8.3.1: 随访建议、治疗方案、多次诊断结果移动到左侧下部“病历信息”中显示
const version = 'V8.3.2-pre';

const race = [
    {value:"汉族" ,label:'汉族'},
    {value:2 ,label:'蒙古族'},
    {value:3 ,label:'回族'},
    {value:4 ,label:'藏族'},
    {value:5 ,label:'维吾尔族'},
    {value:6 ,label:'苗族'},
    {value:7 ,label:'彝族'},
    {value:8 ,label:'壮族'},
    {value:9 ,label:'布依族'},
    {value:10,label:'朝鲜族'},
    {value:11,label:'满族'},
    {value:12,label:'侗族'},
    {value:13,label:'瑶族'},
    {value:14,label:'白族'},
    {value:15,label:'土家族'},
    {value:16,label:'哈尼族'},
    {value:17,label:'哈萨克族'},
    {value:18,label:'傣族'},
    {value:19,label:'黎族'},
    {value:20,label:'傈僳族'},
    {value:21,label:'佤族'},
    {value:22,label:'畲族'},
    {value:23,label:'高山族'},
    {value:24,label:'拉祜族'},
    {value:25,label:'水族'},
    {value:26,label:'东乡族'},
    {value:27,label:'纳西族'},
    {value:28,label:'景颇族'},
    {value:29,label:'柯尔克孜族'},
    {value:30,label:'土族'},
    {value:31,label:'达翰尔族'},
    {value:32,label:'么佬族'},
    {value:33,label:'羌族'},
    {value:34,label:'布朗族'},
    {value:35,label:'撒拉族'},
    {value:36,label:'毛南族'},
    {value:37,label:'仡佬族'},
    {value:38,label:'锡伯族'},
    {value:39,label:'阿昌族'},
    {value:40,label:'普米族'},
    {value:41,label:'塔吉克族'},
    {value:42,label:'怒族'},
    {value:43,label:'乌孜别克族'},
    {value:44,label:'俄罗斯族'},
    {value:45,label:'鄂温克族'},
    {value:46,label:'德昂族'},
    {value:47,label:'保安族'},
    {value:48,label:'裕固族'},
    {value:49,label:'京族'},
    {value:50,label:'塔塔尔族'},
    {value:51,label:'独龙族'},
    {value:52,label:'鄂伦春族'},
    {value:53,label:'赫哲族'},
    {value:54,label:'门巴族'},
    {value:55,label:'珞巴族'},
    {value:56,label:'基诺族'},
];
for(let i = 0;i < race.length;i++) {
    race[i].value = race[i].label;
}
// console.log("race is ",race);
const createAge = function() {
    let age = [];
    for(let i = 1; i < 150; i++) {
        let tempJson = {};
        tempJson.value = i + '岁';
        tempJson.label = i;
        age.push(tempJson);
    }
    return age;
};
const position = {
    "noDistinguish": {
        "舌头": ["舌体"],
        "头皮": ["前额部", "头顶部",  "头旋部","枕部","颞部"],
        "头面部": ["耳郭", "耳根", "耳垂", "外耳道", "耳前", "耳后", "前额", "颞部", "眉部", "眼周", "鼻部", "面颊", "口唇", "口周", "下颌", "面部"],
        "颈部": ["颈部"],
        "项部": ["项部"],
        "胸部": ["胸部", "乳房", "乳头乳晕", "前胸", "胸胁"],
        "足部": ["足背", "足趾伸侧", "足趾屈侧", "足底", "足心", "足跟", "足趾间", "趾甲"],
        "左下肢": ["大腿", "腹股沟", "大腿内侧", "大腿外侧","膝关节伸侧", "腘窝", "小腿伸侧", "小腿屈侧", "足踝"],
        "右下肢": ["大腿", "腹股沟", "大腿内侧", "大腿外侧","膝关节伸侧", "腘窝", "小腿伸侧", "小腿屈侧", "足踝"],
        "腹部": ["腹部", "脐中"],
        "背部": ["背部"],
        "腰部": ["腰部"],
        "臀部": ["臀部"],
        "手部": ["手掌", "手背", "手指伸侧", "手指屈侧", "手指侧缘", "手指缝", "指甲"],
        "左上肢": ["上臂","上臂外侧","上臂内侧", "肘关节内侧", "肘关节外侧", "前臂外侧", "前臂内侧", "腕部", "腋下", "肩部"],
        "右上肢": ["上臂","上臂外侧","上臂内侧", "肘关节内侧", "肘关节外侧", "前臂外侧", "前臂内侧", "腕部", "腋下", "肩部"],        
        "外阴": ["大腿根部", "会阴部", "阴阜", "肛周", "阴茎根部", "阴茎体部", "龟头", "冠状沟", "阴茎系带", "尿道口", "阴囊", "大阴唇外侧", "大阴唇内侧", "阴蒂", "小阴唇", "阴道口", "阴道壁", "宫颈口"],
        "全身": ["全身"]
    },
    "man": {
        "舌头": ["舌体"],
        "头皮": ["前额部", "头顶部",  "头旋部","枕部","颞部"],
        "头面部": ["耳郭", "耳根", "耳垂", "外耳道", "耳前", "耳后", "前额", "颞部", "眉部", "眼周", "鼻部", "面颊", "口唇", "口周", "下颌", "面部"],
        "颈部": ["颈部"],
        "项部": ["项部"],
        "胸部": ["胸部", "乳房", "乳头乳晕", "前胸", "胸胁"],
        "足部": ["足背", "足趾伸侧", "足趾屈侧", "足底", "足心", "足跟", "足趾间", "趾甲"],
        "左下肢": ["大腿", "腹股沟", "大腿内侧", "大腿外侧","膝关节伸侧", "腘窝", "小腿伸侧", "小腿屈侧", "足踝"],
        "右下肢": ["大腿", "腹股沟", "大腿内侧", "大腿外侧","膝关节伸侧", "腘窝", "小腿伸侧", "小腿屈侧", "足踝"],
        "腹部": ["腹部", "脐中"],
        "背部": ["背部"],
        "腰部": ["腰部"],
        "臀部": ["臀部"],
        "手部": ["手掌", "手背", "手指伸侧", "手指屈侧", "手指侧缘", "手指缝", "指甲"],
        "左上肢": ["上臂","上臂外侧","上臂内侧", "肘关节内侧", "肘关节外侧", "前臂外侧", "前臂内侧", "腕部", "腋下", "肩部"],
        "右上肢": ["上臂","上臂外侧","上臂内侧", "肘关节内侧", "肘关节外侧", "前臂外侧", "前臂内侧", "腕部", "腋下", "肩部"],  
        "外阴": ["大腿根部", "会阴部", "阴阜", "肛周", "阴茎根部", "阴茎体部", "龟头", "冠状沟", "阴茎系带", "尿道口", "阴囊"],
        "全身": ["全身"]
    },
    "woman": {
        "舌头": ["舌体"],
        "头皮": ["前额部", "头顶部",  "头旋部","枕部","颞部"],
        "头面部": ["耳郭", "耳根", "耳垂", "外耳道", "耳前", "耳后", "前额", "颞部", "眉部", "眼周", "鼻部", "面颊", "口唇", "口周", "下颌", "面部"],
        "颈部": ["颈部"],
        "项部": ["项部"],
        "胸部": ["胸部", "乳房", "乳头乳晕", "前胸", "胸胁"],
        "足部": ["足背", "足趾伸侧", "足趾屈侧", "足底", "足心", "足跟", "足趾间", "趾甲"],
        "左下肢": ["大腿", "腹股沟", "大腿内侧", "大腿外侧","膝关节伸侧", "腘窝", "小腿伸侧", "小腿屈侧", "足踝"],
        "右下肢": ["大腿", "腹股沟", "大腿内侧", "大腿外侧","膝关节伸侧", "腘窝", "小腿伸侧", "小腿屈侧", "足踝"],
        "腹部": ["腹部", "脐中"],
        "背部": ["背部"],
        "腰部": ["腰部"],
        "臀部": ["臀部"],
        "手部": ["手掌", "手背", "手指伸侧", "手指屈侧", "手指侧缘", "手指缝", "指甲"],
        "左上肢": ["上臂","上臂外侧","上臂内侧", "肘关节内侧", "肘关节外侧", "前臂外侧", "前臂内侧", "腕部", "腋下", "肩部"],
        "右上肢": ["上臂","上臂外侧","上臂内侧", "肘关节内侧", "肘关节外侧", "前臂外侧", "前臂内侧", "腕部", "腋下", "肩部"],  
        "外阴": ["大腿根部", "会阴部", "阴阜", "肛周", "大阴唇外侧", "大阴唇内侧", "阴蒂", "小阴唇", "尿道口", "阴道口", "阴道壁", "宫颈口"],
        "全身": ["全身"]
    }
}

const skinOptions = [{
  value: '黄色',
  label: '黄色'
},{
  value: '白色',
  label: '白色'
},{
  value: '棕色',
  label: '棕色'
},{
  value: '黑色',
  label: '黑色'
},
]
const skinStpeOptions= [{
    value: 'I型',
    label: 'I型'
},{
    value: 'II型',
    label: 'II型'
},{
    value: 'III型',
    label: 'III型'
},{
    value: 'IV型',
    label: 'IV型'
},
  {
    value: 'V型',
    label: 'V型'
  },{
    value: 'VI型',
    label: 'VI型'
  }
]
const applyUnit = [
    {value: '皮肤科',label: '皮肤科'},
    {value: '内科',label: '内科'},
    {value: '外科',label: '外科'}
]

const educationOptions = [
    {value: '初中及以下', label: '初中及以下'},
    {value: '高中', label: '高中'},
    {value: '大专', label: '大专'},
    {value: '本科', label: '本科'},
    {value: '研究生及以上', label: '研究生及以上'},
]

const professionOptions = [
    {value: '机关企事业单位类', label: '机关企事业单位类'},
    {value: '专业技术类', label: '专业技术类'},
    {value: '农林牧渔劳动类', label: '农林牧渔劳动类'},
    {value: '商业类', label: '商业类'},
    {value: '服务类', label: '服务类'},
    {value: '海陆空军人', label: '海陆空军人'},
    {value: '离退休', label: '离退休'},
    {value: '家务劳动者', label: '家务劳动者'},
    {value: '无业', label: '无业'},
    {value: '学生', label: '学生'},
]

const smokingOptions = [
    {value: '从未吸烟', label: '从未吸烟'},
    {value: '偶尔吸烟(一生中未连续或累积吸烟6个月)', label: '偶尔吸烟(一生中未连续或累积吸烟6个月)'},
    {value: '吸烟(一生中连续或累积吸烟6个月或以上)', label: '吸烟(一生中连续或累积吸烟6个月或以上)'},
    {value: '已戒烟', label: '已戒烟'},
]

const drinkingOptions = [
    {value: '从未饮酒', label: '从未饮酒'},
    {value: '偶尔饮酒(≤1次/月)', label: '偶尔饮酒(≤1次/月)'},
    {value: '饮酒(≥1次/月)', label: '饮酒(≥1次/月)'},
    {value: '已戒酒', label: '已戒酒'},
]

const dietHabitOptions = [
    {value: '正常', label: '正常'},
    {value: '高盐', label: '高盐'},
    {value: '高糖', label: '高糖'},
    {value: '高脂', label: '高脂'},
    {value: '烧烤煎炸', label: '烧烤煎炸'},
    {value: '素食', label: '素食'},
    {value: '肉食', label: '肉食'},
    {value: '偏食', label: '偏食'},
    {value: '节食', label: '节食'},
    {value: '暴饮暴食', label: '暴饮暴食'},
]

// 自定义菜单备注
// let config_menu = [
//     {code:'NAV_INTELL', default_name:'影像检查', 'note': '导航-影像检查'},
//     {code:'NAV_PATIENTS', default_name:'患者管理', 'note': '导航-患者管理'},
//     {code:'NAV_OPERATION', default_name:'手术管理', 'note': '导航-手术管理'},
//     {code:'NAV_HAIRDRESSING', default_name:'美容/治疗', 'note': '导航-美容/治疗'},
//     {code:'NAV_COHORT', default_name:'科研队列', 'note': '导航-科研队列'},
//     {code:'NAV_COSMEREGISTER', default_name:'美容预约', 'note': '导航-美容预约'},
//     {code:'NAV_SEARCH', default_name:'高级搜索', 'note': '导航-高级搜索'},
//     {code:'NAV_COUNT', default_name:'统计数据', 'note': '导航-统计数据'},
//     {code:'INTELLIGENT_TYPE_CLINIC', default_name:'大体图/伍德灯', 'note': '影像检查-大体图/伍德灯' },
//     {code:'INTELLIGENT_TYPE_DERM', default_name:'皮肤镜', 'note': '影像检查-皮肤镜'},
//     {code:'INTELLIGENT_TYPE_CT', default_name:'CT检查', 'note': '影像检查-CT'},
//     {code:'INTELLIGENT_TYPE_BC', default_name:'B超检查', 'note': '影像检查-B超'},
//     {code:'INTELLIGENT_TYPE_BL', default_name:'病理检查', 'note': '影像检查-病理'},
//     {code:'COLLECTTYPE_CT_IMAGE_VIEW', default_name:'CT影像所见', 'note': '影像检查页面-CT影像所见'}
//     {code:'INTELLIGENT_SUGGESTION', default_name:'建议', 'note': '影像检查页面-建议'},
//     {code:'INTELLIGENT_DIAGNOSIS', default_name:'影像诊断', 'note': '影像检查页面-影像诊断'},

//     {code:'PATIENTS_LABEL_ADD_DIAGNOSIS', default_name:'影像', 'note': '患者管理页面-添加-影像检查'},
// ]

const optionObj = {
    raceObj : race,
    position: position,
    skinOpn : skinOptions,
    skinOpnType : skinStpeOptions,
    age: createAge(),
    applyUint: applyUnit,
    educationOptions: educationOptions,
    professionOptions: professionOptions,
    smokingOptions: smokingOptions,
    drinkingOptions: drinkingOptions,
    dietHabitOptions: dietHabitOptions,
    version: version,
};
export default optionObj;
